import { request } from '../@utils'
import { requestFile } from '../@utils'
const InventoryService = {
  getStatics: params => {
    return request.post('inventory/stock/list/statistic', { data: params })
  },
  getStockList: params => {
    return request.post('inventory/stock/list/real', { data: params })
  },
  getStockHistoryBuSkuid: data => {
    return request.post(`inventory/stock/history`, { data })
  },
  updateStockBySkuid: data => {
    return request.post(`inventory/stock/update`, { data })
  },
  exportStockList: data => {
    return requestFile.post(`inventory/stock/export`, {
      data: data,
      responseType: 'blob'
    })
  },
  getCheckSheetDeail: checkNo => {
    return request.get(`inventory/check-sheet/detail/${checkNo}`)
  },
  getCheckSheetDeailProductList: data => {
    return request.post(`inventory/check-sheet/detail-product`, { data })
  },
  getCheckSheetList: data => {
    return request.post(`inventory/check-sheet/list`, { data })
  },
  getCheckSheetNo: () => {
    return request.get(`inventory/check-sheet/no`)
  },
  createCheckSheet: data => {
    return request.post(`inventory/check-sheet/create`, { data })
  },
  //盘点单操作-完成
  completeCheckSheet: data => {
    return request.post(`inventory/check-sheet/complete`, { data })
  },
  queryCheckSheetProductList: data => {
    return request.post(`inventory/check-sheet/query-product`, { data })
  },
  checkSheetExport: data => {
    return requestFile.post(`inventory/check-sheet/export`, {
      data: data,
      responseType: 'blob'
    })
  },
  deleteCheckSheet: checkNo => {
    return request.post(`inventory/check-sheet/delete/${checkNo}`)
  },
  // 线上商品库存
  getvirtualList: params => {
    return request.post('/inventory/stock/list/virtual', { data: params })
  },
  // 线上商品库存流水
  getonlineList: params => {
    return request.post('/inventory/stock/history/online', { data: params })
  },
  // 批量设置线上销售库存
  updateonlineList: params => {
    return request.post('/inventory/stock/batch/update', { data: params })
  },
  // 导出线上销售库存
  downLoadOnline: async (params) => {
    const res = await requestFile.post("/inventory/stock/export/online",{ data: params, responseType: "blob" });
    return res;
  },
  // 导入线上销售库存
  upLoadOnline: params => {
    return request.post('/inventory/stock/import-stock', { data: params })
  },
  // 创建调拨单
  allocationCreate: params => {
    return request.post('/inventory/allocation/create', { data: params })
  },
  // 创建调拨单并提交
  allocationCreateSubmit: params => {
    return request.post('/inventory/allocation/create/submit', { data: params })
  },
  // 作废
  allocationDiscard: checkNo =>{
    return request.post(`/inventory/allocation/discard/${checkNo}`)
  },
  // 调拨单查询列表导出
  allocationInExport: params => {
    return requestFile.post('/inventory/allocation/in/export', {
      data: params,
      responseType: 'blob'
    })
  },
  allocationOutExport: params => {
    return requestFile.post('/inventory/allocation/out/export', {
      data: params,
      responseType: 'blob'
    })
  },
  // 生成调拨单号
  allocationGenerateNo:() => {
    return request.get('/inventory/allocation/generate/no')
  },
  // 调拨单查询列表
  allocationInList: params => {
    return request.post('/inventory/allocation/in/list', {data: params})
  },
  // 确认入库
  allocationInWarehouseNo: params => {
    return request.post(`/inventory/allocation/in/warehouse`, {data:params})
  },
  // 操作日志
  allocationOperateLogs: params => {
    return request.get(`/inventory/allocation/operate/logs`, {params})
  },
  // 调拨单查询列表
  allocationOutList: params => {
    return request.post('/inventory/allocation/out/list', {data: params})
  },
  // 确认出库
  allocationOutWarehouseNo: no => {
    return request.post(`/inventory/allocation/out/warehouse/${no}`)
  },
  allocationDetail: no =>{
    return request.get(`/inventory/allocation/detail/${no}`)
  }
}

export default InventoryService
